export const CreateTidbitActionTypes = {
  CREATE_TIDBIT_LOADING: "CREATE_TIDBIT_LOADING",
  CREATE_TIDBIT_ERROR: "CREATE_TIDBIT_ERROR",
  CREATE_TIDBIT_SUCCESS: "CREATE_TIDBIT_SUCCESS",
};
